import { Cookie } from 'coveo-search-ui';
import * as $ from 'jquery';

export class SearchHelper
{
	private cookieKey;
	static recentSearchTermChangeEvent = "recentSearchTermChangeEvent";
	private static _instance: SearchHelper;
	private _terms: string[];

	get terms(): string[] {
		return this._terms.slice(0);
	}

	get hasSearchTerms(): boolean {
		return this._terms.length > 0;
	}

	private constructor()
	{
		this._terms = this.readTermsFromCookies();
		let data = $("#sef-context-data").data();
		this.cookieKey = data['recentSearchesCookie'];
	}

	public addSearchTerm(t: string) {
		if (!t || !t.length) return;
		var existing = this._terms.indexOf(t);
		if (existing > -1) this._terms.splice(existing, 1);
		if (this._terms.length === 7) this._terms.pop();
		this._terms.unshift(t);
		Cookie.set(this.cookieKey, JSON.stringify(this._terms));
		this.notifySubscribers();
	}

	private readTermsFromCookies() {
		var termsFromCookies = Cookie.get(this.cookieKey);
		return termsFromCookies ? JSON.parse(termsFromCookies) : [];
	}

	private notifySubscribers() {
		$(this).triggerHandler(SearchHelper.recentSearchTermChangeEvent, [ this.terms ]);
	}

	public static get Instance()
	{
		return this._instance || (this._instance = new this());
	}
}



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/models/SearchHelper.ts